// @flow strict

import { Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { getUsersReferedList } from '../../../api/user';
import RedeemRules from './RedeemRules';
import Referrals from './Referrals';

function AdminReferralProgram() {
  const [referralUsers, setReferralUsers] = useState([]);

  const fetchReferedUsers = async () => {
    const res = await getUsersReferedList();
    setReferralUsers(res?.data?.users);
  };

  useEffect(() => {
    fetchReferedUsers();
  }, []);

  return (
    <>
      <div className="mt-5 user-referral container px-3 px-md-5">
        <Tabs
          items={[
            {
              label: 'Redeem Rules',
              key: 'rules',
              children: <RedeemRules />
            },
            {
              label: 'User Referral List',
              key: 'list',
              children: <Referrals referralUsers={referralUsers} />
            },
          ]}
        />
      </div>
    </>
  );
};

export default AdminReferralProgram;